import { RowPlaceDto } from "@/dtos";
import { Places } from "@/entities";

export const formatRowPlaceDto = (places: Places[]): RowPlaceDto[] => {
    return places.map(x => {
        const row: RowPlaceDto = {
            ...x,
            city: x.details?.name,
            active: x.is_active ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}